import Vue from 'vue'
import Vuex from 'vuex'
import ContactHelpers from '../helpers/ContactHelpers'
import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'

import templates from './TemplatesStore'
import contacts from './ContactsStore'
// import users from './UsersStore'
import groups from './GroupsStore'
import clipboard from './ClipboardStore'
import transactions from './TransactionsStore'
import elements from './ElementsStore'
import tasks from './TasksStore'
import alerts from './AlertsStore'
import collections from './CollectionsStore'


//console.log('db is ', db)
var db = fb.database()

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        templates,
        transactions,
        contacts,
        // users,
        groups,
        clipboard,
        elements,
        tasks,
        alerts,
        collections,
    },
 
    state: {
        status: {},
        tenant: null,
        tenantDefault: null,
        user: null,
        offices: [],
        loginStatus: null,
        loading: false,
        loadingItems: [],
        step: null,
        transactionFields: [],
        //templates: [],
        loadedTemplates: false,
        dialogHeight: 500,
        designMode: false,
        selectedKeys: {},
        pageData: {},
        applicationData: {},
    },
    mutations: {
        setSelectedKeys (state, {code, keys}) {
            Vue.set(state.selectedKeys, code, keys)
        },
        setPageData (state, {name, value}) {
            Vue.set(state.pageData, name, value)
        },
        clearPageData (state) {
            Vue.set(state, 'pageData', {})
        },

        setApplicationData (state, {name, value}) {
            Vue.set(state.applicationData, name, value)
        },
        clearApplicationData (state) {
            Vue.set(state, 'applicationData', {})
        },

        saveItems(state, payload) {
            state[payload.name] =  payload.data
        },

        setOfficeActive(state, {officeNumber, value}) {
            let office = state.offices.find(o => o.meta.key == officeNumber)
            if(office)
                office.active = value
        },
  
        status(state, payload) {
            Vue.set(state.status, payload.name, payload.status)
        },

        dialogHeight(state, payload) {
            state.dialogHeight = payload
        },


        setUser (state, user) {
            state.user = user
        },
        setOffices (state, offices) {
            state.offices = offices
        },

        setLoading (state, loading) {
            state.loading = loading
        },
        loginStatus (state, loginStatus) {
            state.loginStatus = loginStatus
            localStorage.setItem('loginStatus', loginStatus)
        },
        startLoading(state, description) {
            state.loadingItems.push(description)
            //console.log('startLoading', state.loadingItems)
        },
        stopLoading(state, description) {
            if(description) {

                let position = state.loadingItems.indexOf(description)
                if(position > -1)
                    state.loadingItems.splice(position,1)
            } else
                state.loadingItems = []
        },
        setTenant (state, tenant) {
            state.tenant = tenant
            localStorage.setItem('tenant', JSON.stringify(tenant))            
        },    
        setTenantDefault (state, tenantDefault) {
            state.tenantDefault = tenantDefault
        },            
        setStep (state, step) {
            state.step = step           
        },       
        setDesignMode (state, newValue) {
            state.designMode = newValue           
        },       
        setTransactionFields (state, transactionFields) {
            state.transactionFields = transactionFields           
        },  
             
    },


    actions: {
        loadTemplates(context) {
            return new Promise(function(resolve, reject) {
                if(context.getters.loadedTemplates)
                    resolve(context.getters.templates)
    
                let ref = db.ref(`tenants/${context.getters.tenantKey}/templates`)
                ref.on('value', function(snap) {
                    console.log('store > loadedTemplates')
                    let templates = FirebaseHelpers.snapshotToArray(snap).sort((a, b) => {
                        if(a.group < b.group) return -1
                        if(a.group > b.group) return 1
                        if(a.name < b.name) return -1
                        if(a.name > b.name) return 1
                        return 0
                    })
                    context.commit('templates', templates)
                    context.commit('loadedTemplates', true)
                    resolve(templates)
                })  
            })
        },
        
        saveTemplate(context, payload) {
            const key = payload.key || payload['.key'] || DataHelpers.getKey()
            let ref = db.ref(`tenants/${context.getters.tenantKey}/templates/${key}`)
            ref.update(FirebaseHelpers.cloneWithoutKey(payload))
        },

        deleteTemplate(context, payload) {
            const key = payload.key || payload['.key']
            let ref = db.ref(`tenants/${context.getters.tenantKey}/templates/${key}`)
            ref.remove()
        }
    },    


    getters: {

        dialogHeight: state => (dialogHeight) => { 
            return state.dialogHeight
        },

        getSelectedKeys: state => (code) => { 
            return state.selectedKeys[code] || []
        },
        getPageData: state => (name) => { 
            return state.pageData[name] || null
        },
        getApplicationData: state => (name) => { 
            return state.applicationData[name] || null
        },

        status: state => (status) => { 
            return state.status[status] || ''
        },

        tenant: state => {
            if(!state.tenant || !state.tenant.key)
                state.tenant = JSON.parse(localStorage.getItem('tenant')) 
            if(!state.tenant || !state.tenant.key)
                return {key:0}
            return state.tenant
        },
        tenantDefault: state => {
            return state.tenantDefault
        },
        tenantKey: (state, getters) => {  
            return getters.tenant.key
        },
        user: state => {
            if(state.user)
                return state.user
            else    
                return {
                    firstName: '',
                    lastName: '',
                    image: '',
                    mobile: '',
                    email: '',
                    uid: '',
                    offices: [],
                }
        },

        offices: state => {
            return state.offices
        },

        officesActive: (state, getters) => {
            return getters.offices.filter(o => o.active)
        },

        loginStatus: state => {
            if(state.loginStatus)
                return state.loginStatus
            else {
                return localStorage.getItem('loginStatus')
            }
        },
        uid: state => {
            if(state.user)
                return state.user.uid
            else
                return ''
        },
        userFullName: state => {
                return ContactHelpers.fullName(state.user)
        },
        loading: state => {
            return state.loading
        },

        loadingMessage: state => {
            if (state.loadingItems.length == 0)
                return ''
            
            return 'Loading ' + state.loadingItems.join(', ')
        },
        step: state => {
            return state.step
        },  
              
        designMode: state => {
            return state.designMode
        },        
        transactionFields: state => {
            return state.transactionFields
        },  

                        
    }

})



// WEBPACK FOOTER //
// ./src/store/Store.js